

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action, State } from 'vuex-class'
import { IProcessingErrors } from '@/features/job/store'
import { GET_JOB_ID, GET_JOB_ERRORS_BY_PROJECT } from '@/system/store/getter-types'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import { IStore } from '@/system/store'

@Component
export default class JobDetailsListByProject extends Vue {
  private readonly maxIssuesInList = 100
  @Prop()
  readonly projectName: string | number | undefined
  @Prop()
  readonly processingErrors!: IProcessingErrors[]

  @State(({ job }: IStore) => job?.selectedJob?.meta?.processingErrorsCount) processingErrorsCount!: number

  private translations = jobDetailsLocalisationKeys
  private pagination = {
    rowsPerPage: 0
  }
  columns = [
    {
      field: ({ line }: IProcessingErrors) => line,
      name: 'line',
      label: 'Row #',
      align: 'left'
    },
    {
      field: ({ errors }: any) => errors[0].location,
      name: 'location',
      label: 'Location',
      align: 'left'
    },
    {
      field: ({ errors }: any) => errors[0].name,
      name: 'startEndTime',
      label: 'Issue name',
      align: 'left'
    },
    {
      field: ({ errors }: any) => errors[0].description,
      name: 'issue',
      label: 'Issue description',
      align: 'left'
    }
  ]

  private title (): string {
    return Number.isSafeInteger(Number(this.projectName))
      ? this.$t(this.translations.PROJECT_NOT_FOUND) as string
      : this.projectName as string
  }

  private get isMoreThanMaxIssueToShow () {
    return this.processingErrorsCount > this.maxIssuesInList
  }

  private get hiddenIssuesCount () {
    return this.processingErrorsCount - this.maxIssuesInList
  }
}
